import { createSlice } from "@reduxjs/toolkit";
import {
  addMediaToFacebook,
  addMediaToStories,
  facebooksendmessage,
  FBautochat,
  FBDisconnect,
  FbhandleLogoutAndReLogin,
  FBProfile,
  fetchFBConversations,
  fetchIgConversations,
  getFBConversationByUser,
  getFbstories,
  getIgConversationByUser,
  getPostComments,
  igDisconnect,
  igProfile,
  insertPostComment,
  instagramsendmessage,
  publishMediaOnInstagram,
  resetUnreadCount,
} from "./facebookThunk";

const facebookSlice = createSlice({
  name: "facebook",
  initialState: {
    conversations: [],
    conversationDetails: {},
    loading: false,
    Fbloading: false,
    error: null,
    message: null,
    profile: {}, // Add a state for profile data
    Comments: [],
    FbDisconnectmessage: null,
    fbstoriessccsess: null,
    fbstorieserror: null,
    fbstoriespanding: false,
    fbReLoginMessage: null,
    getFBConversationByUserloading: null,
    fbSendMessageloading: null,
    convLoading: false
  },
  reducers: {
    setConversations(state, action) {
      console.log(action.payload, "action.payloadaction.payloadaction.payloadaction.payload")
      state.conversations = action.payload;
    },

  },
  extraReducers: (builder) => {
    builder
      // Fetch Conversations
      .addCase(fetchFBConversations.pending, (state) => {
        state.convLoading = true;
        state.error = null;
      })
      .addCase(fetchFBConversations.fulfilled, (state, action) => {
        state.conversations = action.payload;
        state.convLoading = false;
      })
      .addCase(fetchFBConversations.rejected, (state, action) => {
        state.convLoading = false;
        state.error = action.payload;
      })

      // Get Conversation by User
      .addCase(getFBConversationByUser.pending, (state) => {
        state.getFBConversationByUserloading = true;
        state.error = null;
      })
      .addCase(getFBConversationByUser.fulfilled, (state, action) => {
        state.conversationDetails = action.payload;
        state.getFBConversationByUserloading = false;
      })
      .addCase(getFBConversationByUser.rejected, (state, action) => {
        state.getFBConversationByUserloading = false;
        state.error = action.payload;
      })
      .addCase(resetUnreadCount.pending, (state, action) => {
        const { senderId } = action.meta.arg;
        state.conversations = state.conversations.map((conv) =>
          conv.id === senderId ? { ...conv, unreadCount: 0 } : conv
        );
        state.loading = true;
        state.error = null;
      })
      .addCase(resetUnreadCount.fulfilled, (state, action) => {
        const { senderId } = action.payload;
        state.conversations = state.conversations.map((conv) =>
          conv.id === senderId ? { ...conv, unreadCount: 0 } : conv
        );
        state.loading = false;
      })
      .addCase(resetUnreadCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Reset failed';
      })
      .addCase(FBautochat.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(FBautochat.fulfilled, (state, action) => {
        state.FBautochat = action.payload;
        state.loading = false;
      })
      .addCase(FBautochat.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Send Message
      .addCase(facebooksendmessage.pending, (state) => {
        state.fbSendMessageloading = true;
        state.error = null;
      })
      .addCase(facebooksendmessage.fulfilled, (state) => {
        state.fbSendMessageloading = false;
      })
      .addCase(facebooksendmessage.rejected, (state, action) => {
        state.fbSendMessageloading = false;
        state.error = action.payload;
      })

      // Add Media to Instagram
      .addCase(addMediaToFacebook.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addMediaToFacebook.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload;
      })
      .addCase(addMediaToFacebook.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(addMediaToStories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addMediaToStories.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload;
      })
      .addCase(addMediaToStories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Publish Media on Instagram
      .addCase(publishMediaOnInstagram.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(publishMediaOnInstagram.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(publishMediaOnInstagram.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Insert Post Comment
      .addCase(insertPostComment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(insertPostComment.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(insertPostComment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get Post Comments
      .addCase(getPostComments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPostComments.fulfilled, (state, action) => {
        state.loading = false;
        state.Comments.push(action.payload);
      })
      .addCase(getPostComments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getFbstories.pending, (state) => {
        state.fbstoriespanding = true;
        state.fbstorieserror = null;
        state.fbstoriessccsess = null; // Save profile data
      })
      .addCase(getFbstories.fulfilled, (state, action) => {
        state.fbstoriessccsess = action.payload; // Save profile data
        state.fbstoriespanding = false;
      })
      .addCase(getFbstories.rejected, (state, action) => {
        state.fbstoriespanding = false;
        state.fbstorieserror = action.payload;
      })

      // Disconnect

      .addCase(FBDisconnect.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(FBDisconnect.fulfilled, (state, action) => {
        state.loading = false;
        state.FbDisconnectmessage = action?.payload;
      })
      .addCase(FBDisconnect.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(FBProfile.pending, (state) => {
        state.Fbloading = true;
        state.error = null;
      })
      .addCase(FBProfile.fulfilled, (state, action) => {
        state.profile = action.payload; // Save profile data
        state.Fbloading = false;
      })
      .addCase(FBProfile.rejected, (state, action) => {
        state.Fbloading = false;
        state.error = action.payload;
      })

      .addCase(FbhandleLogoutAndReLogin.pending, (state) => {
        state.Fbloading = true;
        state.error = null;
      })
      .addCase(FbhandleLogoutAndReLogin.fulfilled, (state, action) => {
        state.fbReLoginMessage = action.payload; // Save profile data
        state.loading = false;
      })
      .addCase(FbhandleLogoutAndReLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default facebookSlice.reducer;
